const CNavPanel = require('../../index.js');
const config = require('./config.yaml');

class CNavPanel__base extends CNavPanel {
	constructor() {
		super();

		this.config = config;
		this.$burger = $('.js-burger');
		this.$navPanel = $('.js-nav-panel');
		this.$navItems = this.$navPanel.find('.js-nav-item');
	}

	init() {
		this.checkButtonActivity();
		this.changeTitle();

		if (this.$navPanel.length > 0) {
			this.navPanelOpeningAnimation();
		}
	}

	checkButtonActivity() {
		if (this.$burger.length > 0) {
			this.$burger.on('click', e => {
				e.preventDefault();
				// (this.$burger.hasClass('is-active') === true) ? this.$burger.removeClass('is-active') : this.$burger.addClass('is-active');
				if (this.$burger.hasClass('is-active') === true) {
					this.$burger.removeClass('is-active');
					this.changeTitle();
				} else {
					this.$burger.addClass('is-active');
					this.changeTitle();
				}
			});
		}
	}

	navPanelOpeningAnimation() {

		this.$burger.on('click', () => {

			if (this.$navPanel.hasClass('is-expand')) {
				this.$navPanel.velocity(this.config.animation.hide.effect, {
					duration: this.config.animation.hide.duration,
					// тестовая анимация
					begin: () => {
						this.$navItems.velocity('fadeOut', {
							duration: 300
						});
					}
				});

				this.$navPanel.removeClass('is-expand');
				this.$burger.removeClass('is-active');
			} else {
				// прячем попап с формой!
				this.closeMobilePopup('hire-us');

				this.$navPanel.velocity(this.config.animation.show.effect, {
					duration: this.config.animation.show.duration,
					begin: () => {
						this.$navPanel.css('display', 'block');
					},
					// тестовая анимация
					complete: () => {
						let delay = 0;

						this.$navItems.each((i, item) => {
							$(item).velocity('transition.flipBounceYIn', {
								duration: 200,
								delay: delay,
							});
							delay += 100;
						});
					}
				});
				this.$navPanel.addClass('is-expand');
				this.$burger.addClass('is-active');
			}
		});
	}

	changeTitle() {
		(this.$burger.hasClass('is-active') === true) ? this.$burger.attr('title', `${this.config.burgerTitle.close}`) :this.$burger.attr('title', `${this.config.burgerTitle.open}`);
	}

	closeMobilePopup(popupClass) {
		if($(`[data-popup-id=${popupClass}]`).length)AR.components.cPopup_base.closePopup(popupClass, 'transition.bounceDownIn');
	}
}

AR.waitComponents(['cPopup_base'], () => {
	const cNavPanel__base = new CNavPanel__base();
	// Вызов метода со всеми событиями
	cNavPanel__base.init();
	// Добавление в глобальный объект AR.components
	AR.pushComponent(cNavPanel__base, 'cNavPanel__base');
});




// WEBPACK FOOTER //
// ./temp/components/nav-panel/.variant/base/index.js